import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['facilitatorId', 'facilitatorIdFieldset'];

  connect() {
    this.facilitatorIdEl = document.querySelector('[name="integration[config][facilitator]"]');

    if (this.facilitatorIdEl.value === 'default_id') this.showFacilitatorId();
  }

  showFacilitatorId() {
    this.facilitatorIdTarget.disabled = false;
    this.facilitatorIdFieldsetTarget.classList.remove('hidden');
  }

  hideFacilitatorId() {
    this.facilitatorIdTarget.disabled = true;
    this.facilitatorIdFieldsetTarget.classList.add('hidden');
  }
}
